import React, { useState } from 'react';
//import './navbar.css';
import { Dropdown } from 'react-bootstrap';
import axios from "axios";
import { BsFiletypeDocx } from "react-icons/bs";

const Preparazione_documenti_alunno = (props) => {


    function preparazione_documenti(tipo_documento) {
        console.log('Preprazione documenti alunno');
        const nuovo_alunno = {
            id: props.alunno._id,
            nome: props.alunno.nome,
            cognome: props.alunno.cognome,
            codice_fiscale: props.alunno.codice_fiscale,
            tipo_documento: tipo_documento 
        }
//        console.log(nuova_ditta);
        axios.post('/transfer_s3/preparazione_documento_file_word', nuovo_alunno)
        .then((res) => {
            console.log('RIENTRATO')

            console.log(res.data)
            if (tipo_documento === 'formazione_a') download_docx('formazione_kerase_a_docx')
            if (tipo_documento === 'formazione_b') download_docx('formazione_kerase_b_docx')
            if (tipo_documento === 'formazione_c') download_docx('formazione_kerase_c_docx')

            //                SET_variab_aggiorna(JSON.stringify(res.data))
        }).catch((error) => {
            console.log(error)
        });
    }


    const download_docx = (indirizzo) => {
        const cognome = props.alunno.cognome
        const nome = props.alunno.nome
        axios.get('/transfer_s3/progetto_docx_ottieni_url/' + indirizzo + '/' + cognome + '/' + nome )
            .then((res) => {
                console.log('xxxxxxxxxxxxxxxxx url ottenuti dal router')
                console.log(res.data)
                const newWindow = window.open(res.data, '_blank', 'noopener,noreferrer')

                if (newWindow) newWindow.opener = null
               
//                return res.data
            }).catch((error) => {
                console.log('ottieni_url url errore')
                console.log(error)
            });
    };



//    const [somma, calcola_somma] = useState('');
    return (
        <>
          
     

        
        <Dropdown.Item onClick={() => preparazione_documenti('formazione_a')}> <div class="d-flex justify-content-between"> Compila Formazione Rischio Basso<BsFiletypeDocx /> </div> </Dropdown.Item>
        <Dropdown.Item onClick={() => preparazione_documenti('formazione_b')}> <div class="d-flex justify-content-between"> Compila Formazione Rischio Medio <BsFiletypeDocx /> </div>  </Dropdown.Item>
        <Dropdown.Item onClick={() => preparazione_documenti('formazione_c')}> <div class="d-flex justify-content-between"> Compila Formazione Rischio Alto <BsFiletypeDocx /> </div>  </Dropdown.Item>
        <div class="dropdown-divider"></div>


    </>
    )
}
export default Preparazione_documenti_alunno;